import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  formattedTime: string = 'HH:mm';
  formattedWeekDay: string = 'ccc';
  formattedDayMonthTime: string = 'dd.MM. HH:mm';
  formattedDayMonthYear: string = 'dd MMMM yyyy';
  formattedDate: string = 'ccc dd.MM.';
  formattedDateTime: string = 'ccc dd.MM. HH:mm';
  formattedDayMonthYearTime: string = ' dd.MM.yyyy HH:mm';
  formattedDateYearTime: string = 'ccc dd.MM.yyyy HH:mm';
  formattedFullDate: string = 'EEEE, dd.MM.yyyy HH:mm';
  formattedMonthYear: string = 'MM/yyyy';
  formattedMonthNameYear: string = 'MMM yyyy';

  constructor() {}

  formatMonthYear(year: number, month: number): string {
    const date = new Date(year, month - 1);

    return formatDate(date, this.formattedMonthYear, 'en-US');
  }

  formatDateTime(date: string): string {
    return formatDate(date, this.formattedDayMonthYearTime, 'en-US');
  }
}
